import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logger from '../utils/logger';
import { getFullUrl } from '../config/apiConfig';
import { userPool } from '../services/cognitoService';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [processing, setProcessing] = useState(true);
  const hasProcessed = useRef(false);

  // Handle payment success
  const handlePaymentSuccess = async () => {
    try {
      // Get pending package and form data from localStorage
      const pendingPackage = localStorage.getItem('pendingPackage');
      const formData = localStorage.getItem('purchaseFormData');
      
      // Get CHECKOUT_SESSION_ID from query string
      const urlParams = new URLSearchParams(location.search);
     const checkoutSessionId = urlParams.get('session_id');
      
      if (!pendingPackage || !formData) {
        // navigate('/packages');
        return;
      }
      
      if (!checkoutSessionId) {
        // navigate('/packages');
        return;
      }
      
   
      
      const packageData = JSON.parse(pendingPackage);
      const userFormData = JSON.parse(formData);
      
      // Get user info and token from cookie-based session
      const userInfo = localStorage.getItem('userInfo');
      if (!userInfo) {
        navigate('/packages');
        return;
      }

      const user = JSON.parse(userInfo);
const cognitoUser = userPool.getCurrentUser();
      let currentIdToken = null;
      
      if (cognitoUser) {
        currentIdToken = await new Promise((resolve, reject) => {
          cognitoUser.getSession((err, session) => {
            if (err) {
              reject(err);
              return;
            }
            if (session && session.isValid()) {
              resolve(session.getIdToken().getJwtToken());
            } else {
              reject(new Error('Invalid session'));
            }
          });
        });
      }
      // Get token from backend session
      const sessionResponse = await fetch(getFullUrl('auth/session'), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          idToken: currentIdToken
        })
      });

      if (!sessionResponse.ok) {
         navigate('/packages');
        return;
      }

      await sessionResponse.json();
      const idToken = currentIdToken;

      // Prepare purchase data for backend with user details
      const purchaseData = {
        userId: user.id || 'anonymous',
        packageId: packageData.id,
        packageName: packageData.name,
        price: packageData.price,
        packageDescription: packageData.description,
        packageFeatures: packageData.features, 
        paymentMethod: 'stripe',
        source: 'stripe_checkout',
        checkoutSessionId: checkoutSessionId, // Add Stripe checkout session ID
        grade: userFormData.grade,
         mobile: userFormData.mobile,
        address: userFormData.address,
         name: userFormData.name,
          email: userFormData.email,
        
      };

      // Debug: Check required fields
     
      
      // Send purchase data to your backend
       
      const response = await fetch(getFullUrl('purchase'), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(purchaseData)
      });

  
      
      if (response.ok) {
        const result = await response.json();
     
        
        // Clear pending package and form data
        localStorage.removeItem('pendingPackage');
        localStorage.removeItem('purchaseFormData');
        
        setProcessing(false);
        
        // Show success message
        setTimeout(() => {
          // navigate('/dashboard');
        }, 2000);
      } else {
        const errorText = await response.text();

        setProcessing(false);
        alert(`Payment successful but failed to save package details. Error: ${response.status} - ${errorText}`);
      }
    } catch (err) {
   
      setProcessing(false);
      alert('An error occurred. Please try again or contact support.');
    }
  };

  // Only call handlePaymentSuccess once when component mounts
  useEffect(() => {
    if (!hasProcessed.current) {
      hasProcessed.current = true;
      handlePaymentSuccess();
    }
  }, []); // Empty dependency array - run only once

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-white flex items-center justify-center py-8">
      <div className="max-w-md mx-auto text-center">
        <div className="bg-white rounded-lg shadow-lg p-8">
          {/* Success Icon */}
          <div className="mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>

          {/* Success Message */}
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Payment Successful!
          </h1>
          <p className="text-gray-600 mb-6">
            {processing ? 'Processing your package details...' : 'Redirecting to dashboard...'}
          </p>

          {/* Loading Spinner */}
          {processing && (
            <div className="flex justify-center mb-6">
              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-green-600"></div>
            </div>
          )}

          {/* Success Details */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
            <p className="text-green-800 text-sm">
              Your package has been purchased successfully. We're setting up your access now.
            </p>
          </div>

          {/* Action Button */}
          {!processing && (
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 transition-colors duration-200"
            >
              Go to Dashboard
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
